import template from './template.html';
import './styles.css';

controller.$inject = [];

export function controller() {
    let vm = {};
    this.$onInit = function() {
    vm = this;
    vm.addDays = addDays;
    }
    function addDays(i) {
        const d = new Date(vm.date);
        d.setDate(d.getDate() + i);
        return d;
    }
}

export default () => ({
    template,
    controller,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: {
        data: '=',
        date: '=',
        holidays: '='
    },
    scope: {}
});



// WEBPACK FOOTER //
// ./src/js/components/planner/schedule/index.js